'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MATERIAL_TYPE_DIGITAL = exports.MATERIAL_TYPE_DIGITAL = 'DIGITAL';

var itemTransactionConstants = exports.itemTransactionConstants = {
  REQUEST_ITEM_BUTTON: 'REQUEST_ITEM_BUTTON',
  CANCEL_HOLD_BUTTON: 'CANCEL_HOLD_BUTTON',
  DIGITAL_READING_LINKS: 'DIGITAL_READING_LINKS'
};

var itemTransactionStatus = exports.itemTransactionStatus = function itemTransactionStatus(hold, materialType, hasItemLevelHoldableItems, checkout) {
  var isDigitalHoldReady = hold && hold.get('status') === 'READY_FOR_PICKUP' && materialType === MATERIAL_TYPE_DIGITAL;
  var isDigitalCheckout = checkout && materialType === MATERIAL_TYPE_DIGITAL;
  var hasItemLevelHold = hold && hold.get('itemId');

  // Show the cancel hold button if the item has an existing hold that is not item level,
  // even if the bib is marked as having item level holdable items.
  //
  // This is necessary because if the ILS does not support predetermined item level holds
  // a bib with item level holdable items may or may not be item level holdable.
  var canPlaceItemLevelHolds = hasItemLevelHoldableItems && (!hold || hasItemLevelHold);

  if (hold && !isDigitalHoldReady && !canPlaceItemLevelHolds) {
    return itemTransactionConstants.CANCEL_HOLD_BUTTON;
  } else if (isDigitalCheckout && !hasItemLevelHoldableItems) {
    return itemTransactionConstants.DIGITAL_READING_LINKS;
  }

  return itemTransactionConstants.REQUEST_ITEM_BUTTON;
};

var allItemsUnavailable = exports.allItemsUnavailable = function allItemsUnavailable(manifestations) {
  return (
    // Since manifestations are sorted by availability, if the first item is unavailable they all are.
    ['UNAVAILABLE'].includes(manifestations.first().getIn(['availability', 'status']))
  );
};

/**
 * Returns a bib jacket cover alt text information as (bibTile - author(s))
 *
 * @param {list} authors
 */
var bibJacketCoverAltText = exports.bibJacketCoverAltText = function bibJacketCoverAltText(bibTitle, authors) {
  if (typeof authors !== 'undefined') {
    var authorResult = authors.size > 1 ? authors.join(', ') : authors.join();
    return '' + bibTitle + (authorResult ? ' - ' : '') + authorResult;
  }
  return bibTitle;
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-item/lib/index.js
// module id = 232
// module chunks = 1